import { AbstractControl, AsyncValidator, AsyncValidatorFn, NG_ASYNC_VALIDATORS, ValidationErrors } from '@angular/forms';
import { Directive, forwardRef, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Observable } from 'rxjs';

import { isClientNatural } from './validator';
import { DocumentType, GetClientByDocumentUseCase } from '../../../core';

// noinspection JSAnnotator
@Directive({
    selector: '[isClientNatural][formControlName],[isClientNatural][formControl],[isClientNatural][ngModel]',
    providers: [
        {
            provide: NG_ASYNC_VALIDATORS,
            useExisting: forwardRef(() => IsClientNaturalValidatorDirective),
            multi: true,
        },
    ],
})
export class IsClientNaturalValidatorDirective implements AsyncValidator, OnChanges, OnInit {
    private validator: AsyncValidatorFn;

    @Input()
    isClientNatural = true;

    @Input()
    docType: DocumentType;

    constructor(private getClientByDocumentUseCase: GetClientByDocumentUseCase) {}

    ngOnInit() {
        this.validator = isClientNatural(this.isClientNatural, this.docType, this.getClientByDocumentUseCase);
    }

    ngOnChanges(changes: SimpleChanges) {
        if ('isClientNatural' in changes || 'docType' in changes) {
            this.validator = isClientNatural(this.isClientNatural, this.docType, this.getClientByDocumentUseCase);
        }
    }

    validate(c: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {
        return this.validator(c);
    }
}
